import React from "react";
import { useNavigate } from "react-router";
import { ref, set } from "firebase/database";
import { ArrowLeft } from "lucide-react";

import ClientForm from "../forms/ClientForm";
import { useNotification } from "../../contexts/NotificationContext";
import { database } from "../../firebase/firebase";
import { Button } from "../../components/ui/button";

export default function EditClientPage() {
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const goBack = () => navigate("/admin-management");

  const handleUpdate = (payload: any, key: string) => {
    set(ref(database, `booking/${key}`), payload)
      .then(() => {
        goBack();
        showNotification("success", "Reserva atualizada com sucesso!");
      })
      .catch(() =>
        showNotification(
          "error",
          "Um erro aconteceu ao atualizar essa reserva."
        )
      );
  };

  return (
    <div className="min-h-screen bg-slate-950 px-4 py-6 text-white">
      <header className="mb-6 flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/10"
          onClick={goBack}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">
            Editar reserva
          </p>
          <h1 className="text-2xl font-semibold">Atualizar cliente</h1>
        </div>
      </header>
      <ClientForm onUpdate={handleUpdate} />
    </div>
  );
}
